// extracted by css-extract-rspack-plugin
export default {"TabList":"vD_lq"};